import { NxIconModule, NxStatusIconType } from '@allianz/ng-aquila/icon';
import { NxModalModule } from '@allianz/ng-aquila/modal';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';
import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

import { ModalLayoutConfig, ModalType } from './modal-layout.model';
import { ButtonGroup, ButtonGroupComponent } from '@retail-portal-santander-frontend/remote-shared-ui-button-group';
import { StatusIconComponent } from '@retail-portal-santander-frontend/remote-shared-ui-status-icon';

@Component({
  standalone: true,
  selector: 'allianz-modal-layout',
  templateUrl: './modal-layout.component.html',
  styleUrls: ['./modal-layout.component.scss'],
  imports: [NxIconModule, NxModalModule, NxHeadlineModule, StatusIconComponent, ButtonGroupComponent],
  host: {
    '[class]': 'classAttribute()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalLayoutComponent {
  buttons: InputSignal<ButtonGroup> = input.required();
  config: InputSignal<ModalLayoutConfig> = input.required();

  readonly type: Signal<ModalType> = computed(() => this.config().type);
  readonly status: Signal<NxStatusIconType> = computed(() => this.config().status);
  readonly title: Signal<string> = computed(() => this.config().title);
  readonly classAttribute: Signal<string> = computed(() => {
    return `modal-type-${this.type()}`;
  });
}
